<template>
  <v-card text>
    <v-layout fill-height column>
      <div v-if="add !== ''">
        <v-layout align-center justify-center column fill-height>
          <img
            width="40px"
            src="data:image/svg+xml;utf8;base64,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"
          />
          <span>{{ $t("labels.adBlocker") }}</span>
        </v-layout>
      </div>

      <div v-if="$vuetify.breakpoint.xsOnly">
        <v-layout
          style="background-color: gray"
          justify-center
          :class="{ receiptHight: smallScreen, receiptOverflow: true }"
        >
          <div class="capture" id="section-to-print">
            <pdf-viewer
              height
              v-if="pdf"
              :src="pdf"
              :page="currentPage"
              @numpages="setPages"
            ></pdf-viewer>
          </div>
        </v-layout>
      </div>
      <div v-else>
        <v-container class="pa-5" grid-list-lg>
          <v-flex>
            <v-layout
              style="background-color: gray"
              justify-center
              :class="{ receiptHight: smallScreen, receiptOverflow: true }"
            >
              <div class="capture" id="section-to-print">
                <div class="pdf-page" v-for="i in totalPages" :key="i">
                  <pdf-viewer
                    height
                    v-if="pdf"
                    :src="pdf"
                    :id="i"
                    :page="i"
                    @numpages="setPages"
                  ></pdf-viewer>
                </div>
              </div>
            </v-layout>
          </v-flex>
        </v-container>
      </div>
      <!-- <v-divider></v-divider>
      <v-card-actions v-if="actions">

        <v-btn v-if="!hideclose" :fab="$vuetify.breakpoint.xsOnly" text @click.stop.prevent="$emit('close')">
          <v-icon dark v-if="$vuetify.breakpoint.xsOnly">mdi-close</v-icon>
          <span v-else>Close</span>
        </v-btn>

        <v-spacer></v-spacer>
        <v-btn color="primary" :text="$vuetify.breakpoint.xsOnly"
          :fab="$vuetify.breakpoint.xsOnly" dark @click.stop.prevent="update(invoice)">
          <v-icon dark v-if="$vuetify.breakpoint.xsOnly">mdi-pencil</v-icon>
          <span v-else>Edit</span>
        </v-btn>
        <v-btn color="primary" :text="$vuetify.breakpoint.xsOnly" :fab="$vuetify.breakpoint.xsOnly" dark
          @click.stop.prevent="print()">
          <v-icon dark v-if="$vuetify.breakpoint.xsOnly">mdi-printer</v-icon>
          <span v-else>Print</span>
        </v-btn>
      </v-card-actions> -->
    </v-layout>
  </v-card>
</template>
<script>
import adblock from "vue-adblock";
import pdfMake from "pdfmake/build/pdfmake.min";
import { pdfMake as pdfFonts } from "pdfmake/build/vfs_fonts";
import pdfViewer from "pdfvuer";
import "pdfjs-dist/build/pdf.worker.entry";
import * as vuex from "vuex";
import tableInvoiceTheme from "@/modules/Invoice/bigInvoice/tableInvoiceTheme.js";
import standardInvoice from "@/modules/Invoice/bigInvoice/standardInvoice.js";
import invoiceService from "@/modules/Invoice/service.js";

pdfMake.vfs = pdfFonts.vfs;
export default {
  name: "receipt-invoice",
  props: {
    smallScreen: {
      type: Boolean,
      default: false,
    },
    actions: {
      type: Boolean,
      default: false,
    },
    hideclose: {
      type: Boolean,
      default: false,
    },
    invoice: {
      type: Object,
    },
    qrcode: {},
    offsety: {
      type: Number,
      default: 125,
    },
  },
  components: {
    pdfViewer,
    adblock,
  },
  data() {
    return {
      add: "",
      change: 0,
      totalPages: 1,
      receiptBusiness: null,
      detailedPayment: false,
      currentPage: 1,
      pages: 0,
      pdf: null,
      doc: {
        info: {
          title: "Invoice Preview",
        },
        header: {},
        footer: {},
        content: [],
        styles: {
          businessInfo: {
            alignment: "center",
            fontSize: 8,
          },
          heading: {
            alignment: "center",
            fontSize: 10,
          },
          policy: {
            alignment: "justify",
            fontSize: 6,
          },
          topDetails: {
            margin: [0, 0],
            fontSize: 8,
          },
          invoiceDetails: {
            margin: [0, 2],
            fontSize: 8,
          },
          totals: {
            margin: [0, 0],
            fontSize: 8,
          },
          header: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 0],
          },
          subheader: {
            fontSize: 14,
            bold: true,
            margin: [0, 3, 0, 5],
          },
          tableExample: {
            margin: [0, 5, 0, 5],
          },
          tableHeader: {
            bold: true,
            fontSize: 13,
            color: "black",
          },
          invoiceAddress: {
            bold: false,
            fontSize: 10,
            color: "black",
          },
        },
        pageBreakBefore(
          currentNode,
          followingNodesOnPage,
          nodesOnNextPage,
          previousNodesOnPage
        ) {
          return (
            currentNode.headlineLevel === 1 && followingNodesOnPage.length === 0
          );
        },
      },
    };
  },
  computed: {
    ...vuex.mapGetters("global", ["currentBusiness"]),
    invoiceLabel() {
      return this.currentBusiness?.metadata?.invoicePrintLabel || "Invoice";
    },
    styleObject() {
      const style = {
        height: `calc(100vh - ${this.offsety}px)`,
      };
      return style;
    },
    width() {
      const size = 80;
      const base = size / 0.35277;
      const adjusted = base - (200 / base) * 20;
      return adjusted;
    },
    height() {
      return 2000;
    },
    horizontalLine() {
      return {
        table: {
          widths: ["*"],
          body: [[""], [""]],
          drawLine: true,
        },
        layout: {
          hLineWidth(i, node) {
            return i === 0 || i === node.table.body.length ? 0 : 1;
          },
          vLineWidth(i, node) {
            return 0;
          },
        },
      };
    },
    date() {
      return this.$moment(this.invoice.createdAt).format("MM/DD/YY h:mm a");
    },
  },
  async created() {
    this.$nextTick(async () => {
      this.receiptBusiness = this.currentBusiness;
      if (
        this.invoice.Business &&
        this.invoice.Business.id != this.currentBusiness.id
      ) {
        this.receiptBusiness = this.invoice.Business;
      }

      this.doc.pageSize = "LETTER";
      this.doc.pageOrientation = "horizontal";
      // this.doc.info.title = `${replaceInvoiceLabel(
      //   "Invoice",
      //   this.currentBusiness
      // )} Preview`;
      this.doc.info.title = `${this.invoiceLabel} Preview`;

      if (
        this.currentBusiness.metadata &&
        this.currentBusiness.metadata.invoiceTheme &&
        this.currentBusiness.metadata.invoiceTheme === "tables"
      ) {
        let exitQrPayload = null;
        if (this.currentBusiness.metadata.invoiceExitGuardEnabled) {
          try {
            const exitQrResponse = await invoiceService.getExitQr(this.invoice.id);
            const exitQrData = exitQrResponse.data || exitQrResponse;
            exitQrPayload = exitQrData.payload;
          } catch (error) {
            console.error('Unable to load invoice exit QR', error);
          }
        }
        this.doc.pageMargins = [12, 190, 12, 155];
        this.doc.footer = await tableInvoiceTheme.invoiceFooter(
          this.invoice,
          this.currentBusiness,
          {
            formatPhoneNumber: this.formatPhoneNumber,
            capitalize: this.capitalize,
            date: this.date,
            options: this.$options,
            width: this.width,
            exitQrPayload,
          }
        );
        this.doc.header = await tableInvoiceTheme.invoiceHeader(
          this.invoice,
          this.currentBusiness,
          {
            formatPhoneNumber: this.formatPhoneNumber,
            capitalize: this.capitalize,
            date: this.date,
          }
        );
        this.doc.content = await tableInvoiceTheme.invoice(
          this.invoice,
          this.currentBusiness,
          {
            width: this.width,
            date: this.date,
            capitalize: this.capitalize,
            formatPhoneNumber: this.formatPhoneNumber,
            horizontalLine: this.horizontalLine,
            options: this.$options,
            detailedPayment: this.detailedPayment,
            change: this.change,
            moment: this.$moment,
            qrcode: this.qrcode,
          }
        );
      } else {
        this.doc.pageMargins = [12, 130, 12, 25];
        this.doc.footer = function (currentPage, pageCount) {
          return [
            {
              text: `${currentPage.toString()} of ${pageCount}`,
              alignment: "center",
              margin: [0, 0, 7, 0],
            },
          ];
        };
        this.doc.header = await standardInvoice.invoiceHeader(
          this.invoice,
          this.currentBusiness,
          {
            formatPhoneNumber: this.formatPhoneNumber,
            capitalize: this.capitalize,
            date: this.date,
          }
        );
        this.doc.content = await standardInvoice.invoice(
          this.invoice,
          this.currentBusiness,
          {
            width: this.width,
            date: this.date,
            capitalize: this.capitalize,
            formatPhoneNumber: this.formatPhoneNumber,
            horizontalLine: this.horizontalLine,
            options: this.$options,
            detailedPayment: this.detailedPayment,
            change: this.change,
            moment: this.$moment,
            qrcode: this.qrcode,
          }
        );
      }

      pdfMake.createPdf(this.doc).getDataUrl((data) => {
        this.pdf = data;
      });
      this.$emit("pdfDocument", this.doc);
    });
  },
  methods: {
    update(invoice) {
      this.$router.push({ path: `/invoice/${invoice.id}/edit` });
    },
    capitalize(str, lower = false) {
      if (str) {
        return (lower ? str.toLowerCase() : str).replace(
          /(?:^|\s|["'([{])+\S/g,
          (match) => match.toUpperCase()
        );
      }
      return str;
    },
    formatPhoneNumber(phoneNumber) {
      // Ensure the input is a string
      const phoneStr = String(phoneNumber);

      // Remove any non-digit characters
      const cleaned = phoneStr.replace(/\D/g, "");

      // Check if the cleaned string has exactly 10 digits
      // if (cleaned.length !== 10) {
      //   throw new Error('Invalid phone number length. Expected 10 digits.');
      // }

      // Format the cleaned string into (XXX) XXX-XXXX
      const formatted = cleaned.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");

      return formatted;
    },
    setPages(val) {
      this.totalPages = val;
      this.pages = val;
    },
    // print() {
    //   pdfMake.createPdf(this.doc).print()
    // },
  },
};
</script>
<style scoped>
@media print {
  .no-print {
    display: none;
  }

  #section-to-print,
  #section-to-print * {
    visibility: visible;
  }

  #section-to-print {
    position: fixed;
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
    left: 0;
    top: 0;
    width: 100%;
  }

  /* Prevent extra blank pages */
  .capture {
    page-break-inside: avoid;
    overflow: hidden;
    width: 100%;
    max-width: 100%;
  }

  /* Ensure no forced page breaks */
  .capture * {
    page-break-before: avoid;
    page-break-after: avoid;
  }
}

.pdf-page {
  page-break-after: always; /* for print */
  margin-bottom: 10px; /* for screen view, adjust as needed */

  padding-bottom: 5px;
}
</style>
